(() => {
  const roots = document.querySelectorAll('[data-zmp]');
  roots.forEach(initProduct);

  function initProduct(root) {
    const json = root.querySelector('[data-zmp-variants]');
    if (!json) return;
    let variants;
    try { variants = JSON.parse(json.textContent); } catch (_) { return; }
    if (!Array.isArray(variants) || !variants.length) return;

    const money = JSON.parse(root.querySelector('[data-zmp-money]')?.textContent || '{}');
    const buttons = [...root.querySelectorAll('[data-zmp-option]')];
    const sizeOrder = ['3XS', '2XS', 'XS', 'S', 'M', 'L', 'XL', '2XL', '3XL', '4XL', '5XL', '6XL'];
    const sizeAliases = { XXS: '2XS', XXXS: '3XS', XXL: '2XL', XXXL: '3XL', XXXXL: '4XL', XXXXXL: '5XL' };

    function normalizedSize(rawValue) {
      const original = String(rawValue || '').trim();
      let candidate = original.toUpperCase();
      const parenthetical = candidate.match(/\(([^)]+)\)/);
      if (parenthetical) candidate = parenthetical[1];
      candidate = candidate.replace(/\s+/g, '');
      candidate = sizeAliases[candidate] || candidate;
      return sizeOrder.includes(candidate) ? candidate : original;
    }

    root.querySelectorAll('.zmp-sizes').forEach(rail => {
      const sizeButtons = [...rail.querySelectorAll('.zmp-size')];
      sizeButtons.forEach(button => {
        const displayValue = normalizedSize(button.dataset.value);
        button.dataset.displayValue = displayValue;
        const label = button.querySelector('.zmp-size-label');
        if (label) label.textContent = displayValue;
      });
      sizeButtons.sort((a, b) => {
        const aIndex = sizeOrder.indexOf(a.dataset.displayValue);
        const bIndex = sizeOrder.indexOf(b.dataset.displayValue);
        return (aIndex < 0 ? 999 : aIndex) - (bIndex < 0 ? 999 : bIndex);
      }).forEach(button => rail.appendChild(button));
      if (sizeButtons.some(button => (button.dataset.displayValue || '').length > 6)) rail.classList.add('zmp-sizes--wide');
    });
    const initial = variants.find(v => v.id === Number(root.dataset.initialVariant)) || variants.find(v => v.available) || variants[0];
    const selected = [...initial.options];
    const form = root.querySelector('[data-zmp-form]');
    /* Guard the upload before it costs the shopper a failed add: Shopify's own cap is 20MB,
       we stop at 10MB and to the four types the workshop can actually open. */
    const logoField = root.querySelector('[data-zmp-logo]');
    const logoError = root.querySelector('[data-zmp-logo-error]');
    if (logoField) {
      const OK = ['image/png', 'image/jpeg', 'image/svg+xml', 'application/pdf'];
      logoField.addEventListener('change', () => {
        const f = logoField.files?.[0];
        let msg = '';
        if (f && !OK.includes(f.type)) msg = 'Please upload a PNG, JPG, SVG or PDF.';
        else if (f && f.size > 10 * 1024 * 1024) msg = 'That file is over 10MB. Please upload a smaller one.';
        if (msg) logoField.value = '';
        if (logoError) { logoError.textContent = msg; logoError.hidden = !msg; }
      });
    }
    const idInput = form?.querySelector('input[name="id"]');
    const atc = root.querySelector('[data-zmp-atc]');
    const mobileAtc = root.querySelector('[data-zmp-mobile-atc]');
    const availability = root.querySelector('[data-zmp-availability]');
    const price = root.querySelector('[data-zmp-price]');
    const mobilePrice = root.querySelector('[data-zmp-mobile-price]');
    const sku = root.querySelector('[data-zmp-sku]');
    const barcode = root.querySelector('[data-zmp-barcode]');
    const message = root.querySelector('[data-zmp-message]');

    const exactVariant = () => variants.find(v => v.options.every((value, index) => value === selected[index]));
    const possibleVariant = (index, value) => variants.find(v => v.options[index] === value && v.options.every((option, i) => i === index || selected[i] === undefined || option === selected[i]));

    function formatPrice(cents) {
      const template = money[String(cents)];
      if (template) return template;
      return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: root.dataset.currency || 'USD' });
    }

    function update() {
      buttons.forEach(button => {
        const index = Number(button.dataset.optionIndex);
        const active = selected[index] === button.dataset.value;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));
        const possible = possibleVariant(index, button.dataset.value);
        if (button.classList.contains('zmp-size')) button.disabled = !possible || !possible.available;
      });

      root.querySelectorAll('[data-zmp-option-label]').forEach(label => {
        label.textContent = selected[Number(label.dataset.zmpOptionLabel)] || '';
      });

      const variant = exactVariant();
      if (!variant) {
        setPurchaseState(null, 'Choose an available option', 'choose');
        return;
      }
      if (idInput) idInput.value = variant.id;
      if (price) price.innerHTML = formatPrice(variant.price) + (variant.compare_at_price > variant.price ? `<s>${formatPrice(variant.compare_at_price)}</s>` : '');
      if (mobilePrice) mobilePrice.textContent = formatPrice(variant.price);
      if (sku) sku.textContent = variant.sku ? `SKU ${variant.sku}` : '';
      if (barcode) barcode.textContent = variant.barcode ? `EAN ${variant.barcode}` : '';
      if (variant.featured_media?.id) showMediaId(variant.featured_media.id);
      setPurchaseState(variant, variant.available ? 'In stock' : 'Out of stock', variant.available ? 'in-stock' : 'out');
      const url = new URL(location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState({}, '', url);
    }

    function setPurchaseState(variant, text, state) {
      if (availability) { availability.textContent = text; availability.dataset.state = state; }
      [atc, mobileAtc].forEach(button => {
        if (!button) return;
        button.disabled = !variant?.available;
        button.textContent = variant?.available ? 'Add to cart' : state === 'out' ? 'Out of stock' : 'Choose options';
      });
    }

    buttons.forEach(button => button.addEventListener('click', () => {
      if (button.disabled) return;
      selected[Number(button.dataset.optionIndex)] = button.dataset.value;
      update();
    }));

    let addInFlight = false;
    const cartCountSelector = '[data-cart-count], .cart-count-bubble span[aria-hidden="true"], .cart-bubble__text-count';

    function optimisticCartCount(delta) {
      const snapshot = new Map();
      const bubbles = new Map();
      let currentTotal = 0;
      document.querySelectorAll(cartCountSelector).forEach(element => {
        snapshot.set(element, { text: element.textContent, className: element.className });
        const count = Number.parseInt(element.textContent, 10);
        if (Number.isFinite(count)) currentTotal = Math.max(currentTotal, count);
        element.textContent = String((Number.isFinite(count) ? count : 0) + delta);
        element.classList.remove('hidden');
        const bubble = element.closest('.cart-bubble');
        if (bubble) { bubbles.set(bubble, bubble.className); bubble.classList.remove('visually-hidden'); }
      });
      return {
        total: currentTotal + delta,
        rollback() {
          snapshot.forEach((value, element) => { element.textContent = value.text; element.className = value.className; });
          bubbles.forEach((className, bubble) => { bubble.className = className; });
        }
      };
    }

    function setAddButtonState(label, busy) {
      [atc, mobileAtc].forEach(button => {
        if (!button) return;
        button.disabled = busy;
        button.classList.toggle('is-loading', busy);
        if (busy) button.setAttribute('aria-busy', 'true'); else button.removeAttribute('aria-busy');
        button.textContent = label;
      });
    }

    async function addToCart(event) {
      event?.preventDefault();
      const variant = exactVariant();
      if (!variant?.available || !form || addInFlight) return;
      addInFlight = true;
      setAddButtonState('Adding…', true);
      if (message) { message.hidden = false; message.dataset.state = 'pending'; message.textContent = 'Adding to your cart…'; }
      const optimistic = optimisticCartCount(1);
      const controller = new AbortController();
      const timeout = window.setTimeout(() => controller.abort(), 15000);
      try {
        const sectionIds = [...document.querySelectorAll('cart-items-component[data-section-id]')]
          .map(component => component.dataset.sectionId)
          .filter(Boolean);
        const note = root.querySelector('[data-zmp-personalise]')?.value.trim();
        const logoInput = root.querySelector('[data-zmp-logo]');
        const logo = logoInput?.files?.[0];
        /* A file line item property only survives as multipart/form-data, so the request
           shape depends on whether a logo was attached. JSON otherwise - it keeps the
           section re-render payload that the cart drawer relies on. */
        let response;
        if (logo) {
          const fd = new FormData();
          fd.append('id', variant.id);
          fd.append('quantity', '1');
          if (note) fd.append('properties[Personalisation]', note);
          fd.append('properties[Logo]', logo);
          fd.append('sections', [...new Set(sectionIds)].join(','));
          fd.append('sections_url', window.location.pathname);
          response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
            method: 'POST', body: fd, credentials: 'same-origin', signal: controller.signal
          });
        } else {
          const payload = {
            items: [{ id: variant.id, quantity: 1, ...(note ? { properties: { Personalisation: note } } : {}) }],
            sections: [...new Set(sectionIds)].join(','),
            sections_url: window.location.pathname
          };
          response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            credentials: 'same-origin',
            keepalive: true,
            signal: controller.signal,
            body: JSON.stringify(payload)
          });
        }
        const data = await response.json();
        if (!response.ok) throw new Error(data.description || data.message || 'Unable to add this item.');
        if (message) { message.hidden = false; message.dataset.state = 'success'; message.textContent = 'Added to your cart.'; }
        [atc, mobileAtc].forEach(button => {
          if (!button) return;
          button.disabled = true;
          button.classList.remove('is-loading');
          button.removeAttribute('aria-busy');
          button.textContent = 'Added ✓';
        });
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: { ...data, item_count: optimistic.total },
            sourceId: 'zmp-product-form',
            data: {
              source: 'zmp-product-form',
              itemCount: optimistic.total,
              productId: root.dataset.productId,
              variantId: String(variant.id),
              sections: data.sections || {}
            }
          }
        }));
        await new Promise(resolve => window.setTimeout(resolve, 550));
      } catch (error) {
        optimistic.rollback();
        const errorText = error.name === 'AbortError' ? 'The request timed out. Please try again.' : error.message;
        if (message) { message.hidden = false; message.dataset.state = 'error'; message.textContent = errorText; }
      } finally {
        window.clearTimeout(timeout);
        addInFlight = false;
        [atc, mobileAtc].forEach(button => button?.classList.remove('is-loading'));
        update();
      }
    }
    form?.addEventListener('submit', addToCart);
    mobileAtc?.addEventListener('click', addToCart);

    const slides = [...root.querySelectorAll('[data-zmp-slide]')];
    const thumbs = [...root.querySelectorAll('[data-zmp-thumb]')];
    const count = root.querySelector('[data-zmp-count]');
    let activeIndex = Math.max(0, slides.findIndex(slide => slide.classList.contains('is-active')));
    function showMedia(index) {
      if (!slides.length) return;
      activeIndex = (index + slides.length) % slides.length;
      slides.forEach((slide, i) => slide.classList.toggle('is-active', i === activeIndex));
      thumbs.forEach((thumb, i) => {
        if (i === activeIndex) thumb.setAttribute('aria-current', 'true'); else thumb.removeAttribute('aria-current');
      });
      thumbs[activeIndex]?.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'nearest', inline: 'nearest' });
      if (count) count.textContent = `${activeIndex + 1} / ${slides.length}`;
    }
    function showMediaId(id) {
      const index = slides.findIndex(slide => String(slide.dataset.mediaId) === String(id));
      if (index >= 0) showMedia(index);
    }
    thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => showMedia(index)));
    root.querySelector('[data-zmp-prev]')?.addEventListener('click', () => showMedia(activeIndex - 1));
    root.querySelector('[data-zmp-next]')?.addEventListener('click', () => showMedia(activeIndex + 1));

    const stage = root.querySelector('[data-zmp-stage]');
    let touchX = 0;
    stage?.addEventListener('touchstart', event => { touchX = event.changedTouches[0].clientX; }, { passive: true });
    stage?.addEventListener('touchend', event => {
      const delta = event.changedTouches[0].clientX - touchX;
      if (Math.abs(delta) > 45) showMedia(activeIndex + (delta < 0 ? 1 : -1));
    }, { passive: true });

    root.querySelectorAll('[data-zmp-zoom]').forEach(trigger => trigger.addEventListener('click', () => {
      const dialog = root.querySelector('[data-zmp-zoom-dialog]');
      const image = dialog?.querySelector('[data-zmp-zoom-image]');
      const slide = slides[activeIndex];
      if (!dialog || !image || !slide?.dataset.zoomSrc) return;
      image.src = slide.dataset.zoomSrc;
      image.alt = slide.dataset.alt || '';
      dialog.showModal();
    }));
    root.querySelectorAll('[data-zmp-dialog-close]').forEach(button => button.addEventListener('click', () => button.closest('dialog')?.close()));
    root.querySelectorAll('dialog').forEach(dialog => dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); }));

    const wishlist = root.querySelector('[data-zmp-wishlist]');
    wishlist?.addEventListener('click', () => wishlist.setAttribute('aria-pressed', String(wishlist.getAttribute('aria-pressed') !== 'true')));

    const sizeGuide = root.querySelector('[data-zmp-size-guide-dialog]');
    root.querySelector('[data-zmp-size-guide]')?.addEventListener('click', () => sizeGuide?.showModal());
    const sizeGuideBlock = sizeGuide?.querySelector('[data-zmp-sg]');
    if (sizeGuideBlock) {
      // Split the store's size-chart page into one panel per H2 and add a tab row (like the reference's per-category charts).
      const source = sizeGuideBlock.querySelector('[data-zmp-sg-source]');
      const tabList = sizeGuideBlock.querySelector('[data-zmp-sg-tabs]');
      // Each chart on the page is an H2 inside its own wrapper (section); that wrapper becomes a panel.
      const panels = [];
      source.querySelectorAll('h2').forEach(heading => {
        const panel = heading.parentElement === source ? heading : heading.parentElement;
        if (panels.includes(panel)) return;
        panel.classList.add('zmp-sg-panel');
        panel.hidden = true;
        panel.dataset.title = heading.textContent.replace(/Zees Moto Motorcycle\s*/i, '').replace(/\s*Size Chart/i, '').trim();
        panels.push(panel);
      });
      panels.forEach((panel, index) => {
        panel.dataset.zmpSgPanel = String(index);
        const tab = document.createElement('button');
        tab.type = 'button';
        tab.className = 'zmp-sg-tab';
        tab.setAttribute('role', 'tab');
        tab.dataset.zmpSgTab = String(index);
        tab.textContent = panel.dataset.title;
        tabList.appendChild(tab);
      });
      const key = (sizeGuideBlock.dataset.default || '').slice(0, 4).toLowerCase();
      const selectPanel = index => {
        panels.forEach((panel, i) => { panel.hidden = i !== index; });
        [...tabList.children].forEach((tab, i) => tab.setAttribute('aria-selected', String(i === index)));
      };
      if (panels.length) {
        const start = panels.findIndex(panel => panel.dataset.title.toLowerCase().startsWith(key));
        selectPanel(start >= 0 ? start : 0);
      } else {
        tabList.hidden = true;
      }
      tabList.addEventListener('click', event => {
        const tab = event.target.closest('[data-zmp-sg-tab]');
        if (tab) selectPanel(Number(tab.dataset.zmpSgTab));
      });
    }

    const recs = root.querySelector('[data-zmp-recs]');
    if (recs) {
      fetch(recs.dataset.url).then(response => response.text()).then(html => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const source = doc.querySelector('[data-zmp-recs-source]');
        const track = recs.querySelector('[data-zmp-recs-track]');
        if (!source?.innerHTML.trim() || !track) { recs.hidden = true; return; }
        track.innerHTML = source.innerHTML;
      }).catch(() => { recs.hidden = true; });
      const track = recs.querySelector('[data-zmp-recs-track]');
      recs.querySelector('[data-zmp-recs-prev]')?.addEventListener('click', () => track?.scrollBy({ left: -Math.min(720, innerWidth * .75), behavior: 'smooth' }));
      recs.querySelector('[data-zmp-recs-next]')?.addEventListener('click', () => track?.scrollBy({ left: Math.min(720, innerWidth * .75), behavior: 'smooth' }));
    }

    const ctl = root.querySelector('[data-zmp-ctl]');
    if (ctl) {
      fetch(ctl.dataset.url).then(response => response.text()).then(html => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const source = doc.querySelector('[data-zmp-ctl-source]');
        const grid = ctl.querySelector('[data-zmp-ctl-grid]');
        if (!source?.innerHTML.trim() || !grid) return;
        grid.innerHTML = source.innerHTML;
        ctl.hidden = false;
      }).catch(() => {});

      const ctlMessage = ctl.querySelector('[data-zmp-ctl-message]');
      const openDrawer = () => {
        const drawer = document.querySelector('cart-drawer-component');
        const dialog = drawer?.querySelector('dialog');
        if (dialog && !dialog.open) drawer.querySelector('button.header-actions__action')?.click();
      };
      async function quickAdd(variantId, control) {
        if (!variantId || control.classList.contains('is-busy')) return;
        control.classList.add('is-busy');
        control.disabled = true;
        if (ctlMessage) ctlMessage.hidden = true;
        const optimistic = optimisticCartCount(1);
        try {
          const sectionIds = [...document.querySelectorAll('cart-items-component[data-section-id]')].map(component => component.dataset.sectionId).filter(Boolean);
          const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }], sections: [...new Set(sectionIds)].join(','), sections_url: window.location.pathname })
          });
          const data = await response.json();
          if (!response.ok) throw new Error(data.description || data.message || 'Unable to add this item.');
          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: { resource: { ...data, item_count: optimistic.total }, sourceId: 'zmp-complete-the-look', data: { source: 'zmp-complete-the-look', itemCount: optimistic.total, productId: String(data.product_id || ''), variantId: String(variantId), sections: data.sections || {} } }
          }));
          control.classList.add('is-added');
          if (control.tagName === 'SELECT') { control.options[0].textContent = 'Added \u2713'; control.value = ''; } else { control.textContent = 'Added \u2713'; }
          window.setTimeout(openDrawer, 200);
          window.setTimeout(() => {
            control.classList.remove('is-added');
            if (control.tagName === 'SELECT') control.options[0].textContent = 'Choose size'; else control.textContent = 'Add to cart';
          }, 2500);
        } catch (error) {
          optimistic.rollback();
          if (control.tagName === 'SELECT') control.value = '';
          if (ctlMessage) { ctlMessage.hidden = false; ctlMessage.textContent = error.message; }
        } finally {
          control.classList.remove('is-busy');
          control.disabled = false;
        }
      }
      ctl.addEventListener('change', event => {
        const select = event.target.closest('select[data-zmp-quickshop]');
        if (select && select.value) quickAdd(select.value, select);
      });
      ctl.addEventListener('click', event => {
        const button = event.target.closest('button[data-zmp-quick-add]');
        if (button) quickAdd(button.dataset.zmpQuickAdd, button);
      });
    }

    const stickyBar = root.querySelector('[data-zmp-mobile-bar]');
    if (stickyBar && atc && 'IntersectionObserver' in window) {
      const header = document.getElementById('header-component');
      let ticking = false;
      const syncTop = () => {
        ticking = false;
        const bottom = header ? Math.max(0, Math.round(header.getBoundingClientRect().bottom)) : 0;
        stickyBar.style.setProperty('--zmp-bar-top', bottom + 'px');
      };
      const onScroll = () => { if (!ticking) { ticking = true; requestAnimationFrame(syncTop); } };
      new IntersectionObserver(entries => {
        const show = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
        stickyBar.classList.toggle('is-visible', show);
        if (show) syncTop();
      }, { threshold: 0 }).observe(atc);
      addEventListener('scroll', onScroll, { passive: true });
      addEventListener('resize', onScroll);
      header?.addEventListener('transitionend', syncTop);
      syncTop();
    }
    update();
  }
})();


